import React from "react";

const ICON_URL =
  "https://customer-assets.emergentagent.com/job_validation-hub-57/artifacts/bj51bcfr_image.png";

/**
 * 3D PRINT HUB brand mark — uses the user-provided printer + gears icon
 * inside a small badge so it pops on dark backgrounds.
 */
export default function BrandIcon({ size = 36, className = "" }) {
  return (
    <span
      className={className}
      style={{
        display: "inline-grid",
        placeItems: "center",
        width: size,
        height: size,
        background: "#FF5722",
        borderRadius: 2,
      }}
      aria-hidden="true"
    >
      <img
        src={ICON_URL}
        alt=""
        style={{
          width: size * 0.78,
          height: size * 0.78,
          objectFit: "contain",
          // White PNG background blends into orange via multiply,
          // leaving the black printer icon visible.
          mixBlendMode: "multiply",
        }}
      />
    </span>
  );
}
